import React from 'react'
import { useParams } from 'react-router-dom'
import { useState,useEffect } from 'react'
import Footer from './Footer'
import Headers from '../Headers'
import {Box,HStack,Image,Text,Link, Spacer,VStack} from "@chakra-ui/react"
import "./home.css"


function IndivualProductPage() {
  const {user_id}=useParams()
  console.log("indu")
const [data,setData]=useState()


useEffect(()=>{
  fetch(`https://6422c67b77e7062b3e224e73.mockapi.io/products/${user_id}`)
  .then((res)=>res.json())
  .then((datat)=>{
    console.log("pro",user_id)
    setData(datat)
  })
},[user_id])
console.log("and",data)

  return (
    <div>
      <Headers />
      <Box margin="20px 40px 20px 20px">
        <Box w="50%" m="15px 15px 0px 30px">
        <HStack>
      <Link href='#' isExternal textDecoration="none" color="black" fontSize="13px" className='links'>Electronics</Link>
      <Spacer />
      <Link href='#' isExternal textDecoration="none" color="black" fontSize="13px" className='links'>Mobiles & Accessories</Link>
      <Spacer />
      <Link href='#' isExternal textDecoration="none" color="black"fontSize="13px" className='links'>Smartphones & Basic Mobiles</Link>
      <Spacer />
      <Link href='#' isExternal textDecoration="none" color="black"fontSize="13px" className='links'>Smartphone</Link>
      
      </HStack>
      </Box>
        <HStack>
        <Image src={data?.avatar} w="50%" h="500px"  m="20px 30px" p="20px"/>
        <Box border="2px solid lightgray" width="" h="auto" padding="10px" margin="50px">
        <h1 style={{fontSize:"20px",margin:"5px",textAlign:"left"}}>{data?.name}</h1>
          <Text m="10px 5px" textAlign="left">{data?.description}</Text>
          <hr/>
          <Text textAlign="left">Deal of the Day</Text>
          <Text color="red" fontSize="20px" textAlign="left">-14% <span style={{color:"black",fontSize:"15px"}}>discount</span> </Text>
          <Text m="10px" fontSize="25px" textAlign="left">{data?.price}.00</Text>
          <hr />
          <Text textAlign="left" fontSize="14px" fontWeight="500" margin="10px 0px">Inclusive of all taxes</Text>
          <Text textAlign="left" fontSize="14px" fontWeight="500" margin="10px 0px">EMI starts at ₹908. No Cost</Text>
          <Text textAlign="left" fontSize="14px" fontWeight="500" margin="10px 0px">EMI available</Text>
          <hr margin="10px 0px"/>
          <VStack>
          
          <button style={{padding:"8px 45px",margin:"5px 0px",backgroundColor:"rgb(247,202,0)" ,color:"black",borderRadius:"5px",border:"none",marginTop:"20px"}}>Add to Cart</button>
          <button style={{padding:"8px 50px",margin:"5px 0px",backgroundColor:"#FFA41C" ,color:"black",borderRadius:"5px",border:"none",marginTop:"10px",marginBottom:"10px"}}>Buy Now</button>
          </VStack>
        </Box>
        <Box>
          <VStack>
            <Box>
              <HStack>
              <Image src="https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/trust_icon_free_shipping_81px._CB630870460_.png"/>
              <Text>Free Delivary</Text>
              </HStack>
            </Box>
            <Box>
              <HStack>
              <Image src="https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-cod._CB485937110_.png"/>
              <Text>Pay On Delivary</Text>
              </HStack>
            </Box>
            <Box>
              <HStack>
              <Image src="https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-returns._CB484059092_.png"/>
              <Text>7 days Replacement</Text>
              </HStack>
            </Box>
            <Box>
              <HStack>
              <Image src="https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-warranty._CB485935626_.png"/>
              <Text>1 Yr Warrenty</Text>
              </HStack>
            </Box>
          </VStack>
        </Box>
        </HStack>
      </Box>
      <Footer />
    </div>
  )
}

export default IndivualProductPage;